import React, { useEffect, useState } from "react";
import MainCard from "../../newTestPreo/components/MainCard";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
  styled,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { fDate } from "../../utils2/formatTime";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const CustomIcon = styled("img")({
  width: "30px",
  height: "24px",
  // position: 'fixed',
  // top: 0,
  // left: 0,
});

function EnrolledClasses() {
  const navigate = useNavigate();
  const enquiryId = localStorage.getItem("enquiryId");
  const enquiryPersonalDetailId = localStorage.getItem(
    "enquiryPersonalDetailId"
  );
  const userId = localStorage.getItem("userId");
  const [data,setData] =useState([])
  const [loading, setLoading] = useState(true);

  const handleViewMore = (row) => {
    // Handle the "View More" action here


    const url = `/viewclassdetails`;
    const newState = { classDetails: row };

    navigate(url, { state: newState });
  };

  useEffect(() => {
    const postData = async () => {
      const data = {
        user_id: parseInt(userId),
        // enquiry_id: parseInt(enquiryId),
        enquiry_personal_detail_id:parseInt (enquiryPersonalDetailId)
      };

      try {
        setLoading(true)
        const res = await fetch(`${API_ENDPOINT}route/allclassses`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        const result = await res.json();
      setData(result);
      setLoading(false)
      } catch (error) {
        console.error('Error:', error);
        setLoading(false)
      }
    };

    postData();
  }, []); 



  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Fetching
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={4} lg={3}>
          <Typography  variant="h2" >
            Enrolled Classes
          </Typography>
        </Grid>
      </Grid>

      <Box m={2} />

    
      <Box m={2} />
      {data.length === 0 ? (
        <Typography variant="h4" color="error">
          No Active Classes
        </Typography>
      ) : (
        <Box>
          <Grid container spacing={4}>
            {data.map((classe, index) => (
              <Grid item xs={6} lg={4}>
                <MainCard>
                  {classe.status_of_student === "active" && (
                    <Button
                      variant="contained"
                      style={{
                        borderRadius: "25px",
                        background: "#019E6F",
                        width: "82px",
                         height: "26px",
                        fontWeight: 500,
                        fontSize: "14px",
                     
                      }}
                    >
                      {" "}
                      Active
                    </Button>
                  )}

{classe.status_of_student === "inactive" && (
                    <Button
                      variant="contained"
                      style={{
                        borderRadius: "25px",
                        background: "#BFBFBF",
                        width: "82px",
                         height: "26px",
                        fontWeight: 500,
                        fontSize: "14px",
                     
                      }}
                    >
                      {" "}
                      Inactive
                    </Button>
                  )}
                  <Typography
                    sx={{ fontSize: "22px", fontWeight: 500, marginTop: "7px" }}
                  >
                    {classe.class_id.name}
                  </Typography>
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: "7px",
                    }}
                  >
                    <Box sx={{ height: "20px", width: "20px" }}>
                      <img src="/Vector (4).png" height="100%" width="100%" />
                    </Box>
                    <Typography
                      sx={{
                        color: "#9A9A9A",
                        marginLeft: "10px",
                        fontSize: "16px",
                        fontWeight: 400,
                      }}
                    >
                      Start Date
                    </Typography>
                    <Typography
                      sx={{
                        color: "#5C5C5C",
                        marginLeft: "15px",
                        fontSize: "16px",
                        fontWeight: 400,
                      }}
                    >
                      {fDate(classe.enrollment_date)}
                    </Typography>
                  </Stack>

                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: "7px",
                    }}
                  >
                    <Box sx={{ height: "20px", width: "20px" }}>
                      <img src="/Vector (5).png" height="100%" width="100%" />
                    </Box>
                    <Typography
                      sx={{
                        color: "#9A9A9A",
                        marginLeft: "10px",
                        fontSize: "16px",
                        fontWeight: 400,
                      }}
                    >
                      Total Sessions
                    </Typography>
                    <Typography
                      sx={{
                        color: "#5C5C5C",
                        marginLeft: "15px",
                        fontSize: "16px",
                        fontWeight: 400,
                      }}
                    >
                      {classe.package_days}{" "}
                    </Typography>

                    {classe.status_of_student === "active" && (
                      <Box sx={{ marginLeft: "70px" }}>
                        <Button
                          variant="contained"
                          style={{ background: "#019E6F" ,borderRadius:'10px'}}
                          onClick={() => handleViewMore(classe.id)}
                        >
                          View Class Details
                        </Button>
                      </Box>
                    )}
  {classe.status_of_student === "inactive" && (
         <Box sx={{ marginLeft: "70px" }}>
<Button
                          variant="contained"
                          disabled
                          style={{ background: "#BFBFBF" , color:'white' , borderRadius:'10px'}}
                        >
                          View Class Details
                        </Button>
                        </Box>
  )}
                  </Stack>
                </MainCard>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}



     
    </>
  );
}

export default EnrolledClasses;
